export default {
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    clear: 'Clear',
    select: 'Select',
    choose: 'Choose',
    upload: 'Upload',
    download: 'Download',
    export: 'Export',
    import: 'Import',
    refresh: 'Refresh',
    update: 'Update',
    create: 'Create',
    remove: 'Remove',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    completed: 'Completed',
    total: 'Total',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    date: 'Date',
    time: 'Time',
    amount: 'Amount',
    price: 'Price',
    quantity: 'Quantity',
    description: 'Description',
    notes: 'Notes'
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    members: 'Members',
    membershipPlans: 'Membership Plans',
    payments: 'Payments',
    attendance: 'Attendance',
    reports: 'Reports',
    trainersPlans: 'Trainers & Plans',
    gymProfile: 'Gym Profile',
    settings: 'Settings',
    logout: 'Log Out'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcomeBack: 'Welcome back',
    totalMembers: 'Total Members',
    activeMembers: 'Active Members',
    monthlyRevenue: 'Monthly Revenue',
    pendingPayments: 'Pending Payments',
    recentMembers: 'Recent Members',
    recentPayments: 'Recent Payments',
    monthlyTrends: 'Monthly Trends',
    quickStats: 'Quick Stats',
    viewAll: 'View All',
    noData: 'No data available',
    revenue: 'Revenue',
    growth: 'Growth',
    thisMonth: 'This Month',
    lastMonth: 'Last Month'
  },

  // Members
  members: {
    title: 'Members',
    addMember: 'Add Member',
    memberList: 'Member List',
    memberDetails: 'Member Details',
    editMember: 'Edit Member',
    deleteMember: 'Delete Member',
    memberName: 'Member Name',
    membershipPlan: 'Membership Plan',
    joinDate: 'Join Date',
    expiryDate: 'Expiry Date',
    contactInfo: 'Contact Information',
    emergencyContact: 'Emergency Contact',
    medicalInfo: 'Medical Information',
    paymentHistory: 'Payment History',
    attendanceHistory: 'Attendance History',
    membershipStatus: 'Membership Status',
    renewMembership: 'Renew Membership',
    suspendMember: 'Suspend Member',
    searchMembers: 'Search members...',
    filterByPlan: 'Filter by plan',
    filterByStatus: 'Filter by status',
    noMembersFound: 'No members found',
    totalMembers: 'Total Members',
    newMembersToday: 'New Members Today',
    expiringThisMonth: 'Expiring This Month'
  },

  // Membership Plans
  plans: {
    title: 'Membership Plans',
    addPlan: 'Add Plan',
    editPlan: 'Edit Plan',
    deletePlan: 'Delete Plan',
    planName: 'Plan Name',
    duration: 'Duration',
    features: 'Features',
    popular: 'Popular',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    yearly: 'Yearly',
    unlimited: 'Unlimited',
    searchPlans: 'Search plans...',
    noPlansFound: 'No plans found',
    planDetails: 'Plan Details',
    subscribedMembers: 'Subscribed Members'
  },

  // Payments
  payments: {
    title: 'Payments',
    addPayment: 'Add Payment',
    editPayment: 'Edit Payment',
    paymentHistory: 'Payment History',
    paymentMethod: 'Payment Method',
    paymentDate: 'Payment Date',
    paymentAmount: 'Payment Amount',
    transactionId: 'Transaction ID',
    paymentStatus: 'Payment Status',
    paid: 'Paid',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    searchPayments: 'Search payments...',
    filterByStatus: 'Filter by status',
    filterByMethod: 'Filter by method',
    noPaymentsFound: 'No payments found',
    totalRevenue: 'Total Revenue',
    todayRevenue: 'Today Revenue',
    pendingAmount: 'Pending Amount',
    cash: 'Cash',
    card: 'Card',
    online: 'Online',
    bank: 'Bank Transfer'
  },

  // Attendance
  attendance: {
    title: 'Attendance',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    attendanceHistory: 'Attendance History',
    attendanceReports: 'Attendance Reports',
    todayAttendance: 'Today Attendance',
    weeklyAttendance: 'Weekly Attendance',
    monthlyAttendance: 'Monthly Attendance',
    presentMembers: 'Present Members',
    absentMembers: 'Absent Members',
    checkInTime: 'Check-in Time',
    checkOutTime: 'Check-out Time',
    duration: 'Duration',
    searchAttendance: 'Search attendance...',
    noAttendanceFound: 'No attendance records found',
    markAttendance: 'Mark Attendance'
  },

  // Reports
  reports: {
    title: 'Reports',
    membershipReport: 'Membership Report',
    revenueReport: 'Revenue Report',
    attendanceReport: 'Attendance Report',
    summaryReport: 'Summary Report',
    generateReport: 'Generate Report',
    exportReport: 'Export Report',
    dateRange: 'Date Range',
    fromDate: 'From Date',
    toDate: 'To Date',
    reportType: 'Report Type',
    noReportsFound: 'No reports found'
  },

  // Gym Profile
  gymProfile: {
    title: 'Gym Profile',
    subtitle: 'Manage your gym\'s branding and profile information',
    gymInfo: 'Gym Information',
    gymName: 'Gym Name',
    gymId: 'Gym ID',
    gymLogo: 'Gym Logo',
    currentLogo: 'Current Logo',
    uploadNewLogo: 'Upload New Logo',
    removeLogo: 'Remove Current Logo',
    logoRequirements: 'Requirements',
    logoUsage: 'Logo Usage',
    logoAppears: 'Where your logo appears:',
    bestPractices: 'Best practices:',
    currencySettings: 'Currency Settings',
    currentCurrency: 'Current Currency',
    selectCurrency: 'Select New Currency',
    chooseCurrency: 'Choose currency...',
    languageSettings: 'Language Settings',
    currentLanguage: 'Current Language',
    selectLanguage: 'Select New Language',
    chooseLanguage: 'Choose language...',
    contactSupport: 'To update gym name, address, or phone number, please contact support.',
    currencyNote: 'Changing your currency will affect all monetary displays in your gym including payments, membership plans, reports, and receipts. This change only affects your gym and will not impact other gyms.',
    languageNote: 'Changing your language will affect all text displays in your gym portal. This change only affects your gym and will not impact other gyms.'
  },

  // Settings
  settings: {
    title: 'Settings',
    description: 'Configure your gym workspace settings, accent theme color, system preferences, and regional timezone.',
    accentPicker: 'System Accent Color Picker',
    accentPickerDesc: 'Pick your preferred accent theme color for your gym workspace and members (default Orange #f97316 or choose a custom color).',
    timezoneTitle: 'Regional Timezone (IST Asia/Kolkata)',
    timezoneDesc: 'Configure system datetime calculations and attendance logs based on Indian Standard Time (IST) or international country timezones.'
  },

  // Forms
  form: {
    firstName: 'First Name',
    lastName: 'Last Name',
    fullName: 'Full Name',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    required: 'Required',
    optional: 'Optional',
    pleaseSelect: 'Please select',
    enterValue: 'Enter value',
    invalidEmail: 'Invalid email address',
    invalidPhone: 'Invalid phone number',
    fieldRequired: 'This field is required',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordsDoNotMatch: 'Passwords do not match'
  },

  // Messages
  messages: {
    memberAdded: 'Member added successfully!',
    memberUpdated: 'Member updated successfully!',
    memberDeleted: 'Member deleted successfully!',
    planAdded: 'Plan added successfully!',
    planUpdated: 'Plan updated successfully!',
    planDeleted: 'Plan deleted successfully!',
    paymentAdded: 'Payment added successfully!',
    paymentUpdated: 'Payment updated successfully!',
    attendanceMarked: 'Attendance marked successfully!',
    profileUpdated: 'Profile updated successfully!',
    logoUploaded: 'Logo uploaded successfully!',
    logoRemoved: 'Logo removed successfully!',
    currencyUpdated: 'Currency updated successfully!',
    languageUpdated: 'Language updated successfully!',
    settingsSaved: 'Settings saved successfully!',
    operationFailed: 'Operation failed. Please try again.',
    networkError: 'Network error. Please check your connection.',
    unauthorizedAccess: 'Unauthorized access. Please login again.',
    confirmDelete: 'Are you sure you want to delete this item?',
    confirmLogout: 'Are you sure you want to log out?'
  },

  // Empty States
  empty: {
    noMembers: 'No members yet',
    noMembersDesc: 'Start by adding your first member to the gym.',
    noPlans: 'No membership plans',
    noPlansDesc: 'Create membership plans to get started.',
    noPayments: 'No payments recorded',
    noPaymentsDesc: 'Payment history will appear here.',
    noAttendance: 'No attendance records',
    noAttendanceDesc: 'Attendance history will appear here.',
    noReports: 'No reports generated',
    noReportsDesc: 'Generate reports to view analytics.',
    noResults: 'No results found',
    noResultsDesc: 'Try adjusting your search or filters.'
  },

  // Pagination
  pagination: {
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    of: 'of',
    showing: 'Showing',
    to: 'to',
    entries: 'entries',
    results: 'results'
  },

  // File Upload
  upload: {
    clickToUpload: 'Click to upload logo',
    dragAndDrop: 'or drag and drop',
    uploading: 'Uploading...',
    processing: 'Processing...',
    fileTypes: 'File types: PNG, JPG, JPEG, GIF, SVG, WEBP',
    maxSize: 'Maximum size: 5MB',
    recommended: 'Recommended: Square aspect ratio (1:1)',
    minResolution: 'Minimum resolution: 200x200 pixels',
    invalidFileType: 'Invalid file type. Please select PNG, JPG, JPEG, GIF, SVG, or WEBP files only.',
    fileTooLarge: 'File size too large. Please select a file smaller than 5MB.',
    uploadFailed: 'Failed to upload file',
    removeFailed: 'Failed to remove file',
    noLogoUploaded: 'No logo uploaded',
    uploadLogoDesc: 'Upload a logo to personalize your gym'
  }
};